  let questions = document.querySelectorAll(".questions");
  questions.forEach(questions => {
    questions.addEventListener("click", event => {
      const active = document.querySelector(".questions.active");
      if (active && active !== questions) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questions.classList.toggle("active");
      const answers = questions.nextElementSibling;
      if (questions.classList.contains("active")) {
        answers.style.maxHeight = answers.scrollHeight + "px";
      } else {
        answers.style.maxHeight = 0;
      }
    })
  })








// Function to apply the toggle behavior
function applyToggleBehavior() {
  document.querySelectorAll('.toggleButton').forEach((button, index) => {
    const content = document.querySelectorAll('.content-tabs')[index];

    button.addEventListener('click', () => {
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        button.textContent = 'Load more...';
      } else {
        document.querySelectorAll('.toggleButton').forEach((button1, index1) => {
          if (index === index1) {
            content.style.maxHeight = content.scrollHeight + 'px';
            button.textContent = 'Load less...';
          } else {
            const content1 = document.querySelectorAll('.content-tabs')[index1];
            content1.style.maxHeight = null;
            button1.textContent = 'Load more...';
          }
        });
      }
    });
  });
}

// Check if the screen width is between 0 and 990px
function checkScreenWidth() {
  if (window.innerWidth <= 990) {
    applyToggleBehavior();
  }
}

// Run the check on initial load
checkScreenWidth();

// Run the check whenever the window is resized
window.addEventListener('resize', checkScreenWidth);
